<template>
  <div
    :class="[
      'tw-w-full tw-flex tw-leading-[100%] tw-justify-between tw-gap-[20px] tw-bg-[#ffffff] default-box',
      customClass,
    ]"
  >
    <div class="tw-flex tw-flex-row tw-flex-1 tw-items-center tw-h-[60px]">
      <span class="tw-relative">
        <span
          :class="[
            'tw-font-poppins tw-text-[#231F20] tw-leading-[140%] tw-font-medium tw-mr-[3px]',
            customTitleStyle,
          ]"
          >{{ title }}</span
        >
      </span>
    </div>
    <div class="tw-flex tw-flex-end tw-items-center tw-bg-[#FFFFFF] tw-flex-1">
      <AssessmentAnswerType1
        v-if="questionType === wizardQuestionAnswerType.radio"
        :value="answerQuestion"
        :is-wizard-page="true"
        :is-true="isTrue"
        @update:value="handleAnswer"
      />
      {{ placeholder }}
      <BaseDropDown
        v-if="questionType === wizardQuestionAnswerType.select"
        :id="'wizard-services-dropdown'"
        v-model="answerQuestion"
        :placeholder="placeholder"
        :custom-select-container="customSelectContainer"
        :data="dropdownData as IDropDownData[]"
        :validation="{}"
        :class-name="'gray-dropdown-container tw-h-[56px]'"
        @update:model-value="handleAnswer"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import AssessmentAnswerType1 from "../assessments/assessmentAnswerType1.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import { wizardQuestionAnswerType } from "@/utils/constants";
import BaseDropDown from "../common/form/baseDropDown.vue";
const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  customTitleStyle: {
    type: String,
    required: false,
    default: "tw-text-[14px]",
  },
  questionType: {
    type: String,
    default: wizardQuestionAnswerType.radio,
  },
  dropdownData: {
    type: Array,
    default: () => [],
  },
  customClass: {
    type: String,
    required: false,
    default: "p-25",
  },
  placeholder: {
    type: String,
    default: "",
  },
  customSelectContainer: {
    type: String,
    required: false,
    default: "",
  },
  isRequired: {
    type: Boolean,
    default: true,
  },
  isTrue: {
    type: [Number, String],
    default: 0,
  },
});
const emits = defineEmits(["check:answer", "update:answer"]);

const answerQuestion = ref(props.isTrue);

const handleAnswer = (answer: any) => {
  answerQuestion.value = answer;
  emits("check:answer", answer);
  emits("update:answer", answer);
};
watch(
  () => props.isTrue,
  (newValue, oldValue) => {
    if (newValue) {
      answerQuestion.value = newValue;
    }
  },
  { deep: true },
);
</script>
<style scoped>
.default-box {
  border-top: 1px solid var(--ui-rule, #eff0f1) !important;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.border-none {
  border: none !important;
}
.p-25 {
  padding: 25px;
}

.custom-box {
  padding: 10px 0px;
}
.custom-staff {
  padding-top: 10px;
}

.custom__no_padding {
  padding-bottom: 10px;
}

.quantity {
  padding-top: 10px;
  padding-bottom: 20px;
}

@media screen and (max-width: 600px) {
  .default-box {
    flex-direction: column;
  }
}
</style>
